module.exports = "/fonts/fa-regular-400.ttf?f33342516f7cbe46f1d6b68f9e7bbeda";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-regular-400.ttf
// module id = toH5
// module chunks = 0 1